<template>
  <Card>
    <h1 slot="Title">Functional Area</h1>
    <div slot="MainContent">
      <p>
        <b>Functional Area, Army Program Element, Management Decision</b>
      </p>
      <p>
        <b>Package & Project Number 131096QLOG</b>
      </p>
      <p>
        The Functional Area is a Funds Management budget object defined as a funds control element as well as an element to capture execution data. All funds will be distributed to specific Functional Areas for execution of funds. A valid Functional Area combination must exist in GFEBS master data before execution actions can take place.
      </p>
      <p>
        202011D20 A76VV <b><u>131096QLOG</u></b> 6100.2617 WBS, Internal Order or Cost Center 1000000067 021001
      </p>
    </div>
    <div slot="Notes">
      <p><span style="color: #ffffff;"><strong>FUNCTIONAL AREA</strong></span></p>
      <p><span style="color: #ffffff;"><strong>Functional Area</strong></span></p>
      <p><span style="color: #ffffff;"><strong>NOTE:&nbsp; Refer students to the Army Management Structure (Federated ERPs) Guide,</strong> <strong>Chapter 5 </strong>and <strong>Summary Sheet; Identify Master Data page #8.</strong></span></p>
      <p><span style="color: #ffffff;"><strong>Definition and Use: </strong>The Functional Area is a Funds Management budget object defined as a funds control element as well as an element to capture execution data. All funds will be distributed to specific Functional Areas for execution of funds. A valid Functional Area combination must exist in GFEBS master data before execution actions can take place. GFEBS records the OSD Program Element in the background for the Functional Area. OMA point account information used in legacy systems may appear in GFEBS Cost Management master data depending on the use cases.</span></p>
    </div>
  </Card>
</template>

<style scoped>
.ThreeWrapper {
  width: 100%;
  margin-bottom: 32px;
}

ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding-left: 0;
}

ul > li {
  width: 33%;
  list-style: none;
  margin-bottom: 0;
}

ul > li > b {
  font-weight: 700;
}

</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'StatesofanAppropriationExamples',
  
  data() {
    return {
    }
  }
  
}
</script>